import { JWTAuth } from "../../../../lib/js-apiclient"
import { AdvancedApiClient } from "../../../../lib/js-apiclient/src/AdvancedApiClient";

export class IntramirrorSeasonMapApiClient extends AdvancedApiClient {

    static entityType = "IntramirrorSeasonMap"

    constructor(token, seasonId, id) {
        super();

        this.setEntityType(IntramirrorSeasonMapApiClient.entityType)

        if(id !== undefined && id !== null) {
            this.setRoute("/api/v1/season/{sid}/intramirror-map/{id}")
                .setRouteParam("sid", seasonId)
                .setRouteParam("id", id);
        } else {
            this.setRoute("/api/v1/season/{sid}/intramirror-map")
                .setRouteParam("sid", seasonId);
        }
        
        if(token !== undefined && token !== null) {
            this.appendAuthSchema(new JWTAuth(token))
        }
    }

}